/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UsersList = {
  type: 'array',
  contains: {
    type: 'User',
  },
} as const;
